import React, {Component, PropType} from 'react';
import LoadingComponent from './LoadingComponent';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { disablePageDescription } from '../../actions/index'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

var SuggestionListStyle = {
    cursor: 'auto',
    background: 'rgba(247, 247, 247, 0.26)',
    borderTop: '1px solid #dddddd',
    borderRight: '1px solid #dddddd'
};

var descriptionListStyle = {
    lineHeight: '20px',
    cursor: 'auto',
    background: 'rgba(247, 247, 247, 0.26)',
    marginTop: '5px',
    borderTop: '1px solid #dddddd',
    borderBottom: '1px solid #dddddd',
    borderRight: '1px solid #dddddd'
};

var descriptionLabelStyle = {
    width: '100%',
    padding: "15px 0px",
    fontSize: '14px',
    marginLeft: '-13px'
};

var descriptionDivStyle = {
    // padding: '0px',
    paddingLeft: '15px',
    float: "left"
};

var descriptionFeedbackStyle = {
    padding: '0px',
    fontSize: "13px",
    textAlign: "right",
    // paddingRight: "20px"
};

var feedbackStyle = {textAlign: "right",marginRight: "34px", marginTop: "-26px"};

class DescriptionComponent extends React.Component{
    constructor(props){
        super(props)
        this.state=props
    }
    // componentDidMount() {
    //     this.setState({data:'loading'});
    // }
    componentDidMount() {
        this.setState({data:'loading'});
        this.getResult(this.props, true);
    }
    componentWillReceiveProps (nextProps) {
        this.getResult(nextProps, true);
    }
    isNextAndPrevPropsSame=(nextProps, props)=> {
        if(nextProps.category == props.category && nextProps.categoryValue == props.categoryValue && nextProps.selectedMetric == props.selectedMetric && nextProps.breakUp == props.breakUp && nextProps.startDate == props.startDate && nextProps.endDate == props.endDate && nextProps.period == props.period && nextProps.chartCat == props.chartCat && nextProps.sortOrder == props.sortOrder && nextProps.point == props.point && nextProps.limit == props.limit && nextProps.metricRange == props.metricRange && nextProps.point == props.point && nextProps.date == props.date && nextProps.insightType == props.insightType && nextProps.enableDescription == props.enableDescription && !nextProps.enableDescription)
        // && !((nextProps.point || nextProps.date))
            return true;
        else return false;
    }
    getResult=(nextProps, enable)=>{
        if(!nextProps.resultAvailable) {
            if(voiceQuestion=="1" || nextProps.chartCat == 'summary')
                enable=false;
            // return true when all variables are same then return false from here means don't call description
            if(enable && this.isNextAndPrevPropsSame(nextProps, this.props))      
                return false;      
            
            // this.props.disablePageDescription(false);
            nextProps = nextProps ? nextProps : this.props;
            this.setState({data: 'loading',voice:null});
            this.getDescription(nextProps);            
        } else {
            this.setState({data: this.modifyResult(this.state.result['result'])});
        }
    }
    getDescription(nextProps) {
        var that = this;
        var dataset = JSON.parse(localStorage.Dataset);
        var voice=0;

        let point = nextProps.point
        let property = nextProps.category
        if (point === 'all' || point === 'page') {
            property = point === 'page' ? null : property
            point = ''            
        }
        var userId = nextProps.authData ? nextProps.authData.userId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");
                        
        let startDate = moment(nextProps.startDate).format('YYYY-MM-DD');
        let endDate = moment(nextProps.endDate).format('YYYY-MM-DD');

        let params = { 'toolId': dataset.toolId, 'siteId': dataset.siteId, 'selectedProperty': property, 'selectedPropertyValue': nextProps.categoryValue, 'breakUp': nextProps.breakUp, 'selectedMetric': nextProps.selectedMetric, 'includeBreakUp': nextProps.include, 'excludeBreakUp': nextProps.exclude, 'startDate': startDate, 'endDate': endDate, 'period': nextProps.period, 'chartType': nextProps.chartCat, 'sortOrder': nextProps.insightSortOrder && nextProps.insightType == 'insight' ? nextProps.insightSortOrder : nextProps.sortOrder, 'limit': nextProps.limit, 'range': nextProps.metricRange, 'type': 1, 'summary': 0, 'point': point, 'dateClicked': nextProps.date, 'insightType': nextProps.insightType, 'dashboard': 'true', 'voice': voiceQuestion };
        let postData = { 'userId': userId }

        CallAPI('POST', '/app/description', postData, params, 0, function (response) {
            checkIfSessionTimedOut(response)
            var data = response
            if (data) {
                var result = that.modifyResult(data['result'])
                that.setState({
                    data: result,
                    detail: data['detail']
                })
            } else {
                voiceQuestion = 0;
                that.setState({ data: null, detail: null });
            }
            that.forceUpdate()
        }, this.props.authData)
        
        /* Commented below jQuery.ajax call & changed it to above CallAPI method */
        // let urlParams = {'toolId':`${dataset.toolId}`,'siteId':`${dataset.siteId}`,'selectedProperty':`${property}`,'selectedPropertyValue':`${nextProps.categoryValue}`,'breakUp':`${nextProps.breakUp}`,'selectedMetric':`${nextProps.selectedMetric}`,'includeBreakUp':`${nextProps.include}`,'excludeBreakUp':`${nextProps.exclude}`,'startDate':`${startDate}`,'endDate':`${endDate}`,'period':`${nextProps.period}`,'chartType':`${nextProps.chartCat}`,'sortOrder':`${nextProps.sortOrder}`,'limit':`${nextProps.limit}`,'range':`${nextProps.metricRange}`,'type':1,'summary':0,'point':`${point}`,'dateClicked':`${nextProps.date}`,'dashboard':'true','voice':`${voiceQuestion}`};
        // jQuery.ajax({
        //     type:'post',
        //     url: `${url}`,
        //     data: postData,
        //     headers: { Authorization: authorization_value },
        //     success:function(response){
        //         checkIfSessionTimedOut(response)
        //         var data = (response && typeof response === 'string') ? JSON.parse(response) : null
        //         if(data) {
        //             var result = that.modifyResult(data['result'])
        //             that.setState({
        //                 data: result,
        //                 detail: data['detail']
        //             })
        //         } else {
        //             voiceQuestion=0;
        //             that.setState({data : null, detail : null});
        //         }
        //         that.forceUpdate()
        //     }
        // });
                
        // jQuery.ajax({
        //     type: 'get',
        //     async: true,
        //     data: 'selectedProperty=' + encodeURIComponent(nextProps.category) + '&selectedPropertyVale=' + encodeURIComponent(nextProps.categoryValue) + '&selectedMetric=' + encodeURIComponent(nextProps.selectedMetric) + '&breakUp=' + encodeURIComponent(nextProps.breakUp) + '&startDate=' + encodeURIComponent(nextProps.startDate) + '&endDate=' + encodeURIComponent(nextProps.endDate) + '&period=' + encodeURIComponent(nextProps.period) + '&chartDisp=' + encodeURIComponent(nextProps.chartCat) + '&sortOrder=' + encodeURIComponent(nextProps.sortOrder) + '&limit=' + encodeURIComponent(nextProps.limit) + '&range=' + encodeURIComponent(nextProps.metricRange) + '&point=' + encodeURIComponent(nextProps.point) + '&date=' + encodeURIComponent(nextProps.date) + '&voice=' + encodeURIComponent(voiceQuestion),
        //     url: '/dashboard/charttype/getdescription',
        //     success: function (data) {
        //         if(data) {
        //             var detail = data['detail'];
        //             var data = data['result'];
        //             that.setState({
        //                 data: that.modifyResult(data),
        //                 detail: detail
        //             });
        //         } else{
        //             voiceQuestion=0;
        //             that.setState({data:null, detail:null});
        //         }
        //     }
        // });
    }     
    modifyResult= (result)=> {
        if (!result) 
            return result;
        var data = [];
        if(typeof result == 'object') { 
            var data = [];
            if(Array.isArray(result[0])) { // means array of objects. It will have data like this. [0] => {id => '1', value => 'some value'}, [1] => {} etc.
                Object.keys(result).map(function(index){
                    var val = result[index];
                    var temp = [];
                    val.map(function(innerData, innerIndex) {
                        temp[innerIndex] = innerData[innerIndex];
                    });
                    data.push(temp);
                });
            } else {    // else this will have data like this result = {id:value, id:value} ex: {0:'some value', 1:'some value'} etc.
                Object.keys(result).map(function(id){
                    var temp = [];
                    var val = result[id];
                    temp['id'] = val['id'];
                    temp['val'] = val['value'];
                    temp['url'] = val['url'];
                    temp['color'] = val['color'];
                    data.push(temp);
                });
            }
        } else if(typeof result == 'array') {
            result.map(function (val) {
                if (val) 
                    data.push(val);
                }
            );
        }
        return data;
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }
    addVoiceText=(text)=>{ 
        if(this.state.voice!=text && voice=='1' && voiceQuestion=="1"){
            voiceQuestion=0;
            this.setState({
                voice:text
            });
            try {
                setTimeout(function(){
                    var msg = new SpeechSynthesisUtterance(text);
                    window.speechSynthesis.speak(msg);
                },500);
            }catch(err){
                console.log(err);
            }
        }
    }
    saveComment=()=>{
        saveComment(this.state.questionId);
    }
    openComment=(type, e)=> {
        openComment(type, e);
    }
    handleComment=(e)=> {
        handleComment(e);
    }
    handleStar=(e)=>{
        handleStar(e);
    }
    render () {
        var descriptionData = null;
        var details = null;
        var that = this;
        if (that.state.data == 'loading') {
            descriptionData = <LoadingComponent/>;
            details = 'loading';
        }
        else if (this.state.data == 'Coming Soon') {
            descriptionData = <div>
                <h1 style={{ textAlign: 'center' }}>{this.state.data}</h1><br/>
            </div>;
        }else if (this.state.data) {
            details = '';
            var data = this.state.data;
            
            descriptionData = Object.keys(data).map(function(dbId, index){
                    var val = data[dbId]; 
                    dbId = val['id'];
                    var url = val['url'];
                    var type = val['type'];
                    var colorCode = val['color'];
                    val = val['val'];
                    if(index===0){
                        this.addVoiceText(val);
                    }
                    var feedbackDislikeId = 'Description_' + dbId + '_Dislike';
                    var feedbackLikeId = 'Description_' + dbId + '_Like';
                    var starId = dbId + '_Star';
                    var commentId = dbId + '_Comment';
                    var color = '#00acec';
                    switch(colorCode) {
                        case 1:
                        case '1':
                            color = '#00acec';
                            break;
                        case 2:
                        case '2':
                            color = 'green';
                            break;
                        case 3:
                        case '3':
                            color = 'red';
                            break;
                    }
                    var borderLeft = '2px solid ' + color;
                    var descriptionListStyle = {lineHeight: '20px',cursor: 'auto',background: 'rgba(247, 247, 247, 0.26)',marginTop: '5px',borderTop: '1px solid #dddddd',borderBottom: '1px solid #dddddd',borderRight: '1px solid #dddddd', borderLeft: borderLeft};

                    url = url ? <span><a href={url} target='_blank' style={{color:'blue'}}> Click here to know more.</a></span> : null;
                    return (
                        <div className="list-group-item d-sm-flex align-items-center justify-content-between borderless mg-r-10 w-100">
                            <div className="wd-95p">{val}{url}</div>
                            <div className="wd-5p d-md-flex">
                                <div className="dropdown-file pd-r-5">
                                    <a href="" className="dropdown-link dropdown" data-bs-toggle="dropdown"><i className="desc-btn fas fa-ellipsis-v"></i></a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" onClick={this.openComment.bind(this, 'like')} id={feedbackLikeId}>
                                            <i className='far fa-thumbs-up pd-r-5'></i> Like
                                        </a>
                                        <a className="dropdown-item" onClick={this.openComment.bind(this, 'disLike')} id={feedbackDislikeId}>
                                            <i className='far fa-thumbs-down pd-r-5'></i> Dislike
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    );
                }.bind(this));
        }
        if(details == 'loading')
            details = null;
        else if (this.state.detail) {
            var detail = this.state.detail;
            var details = Object.keys(detail).map(function (key) {
                return <>{key}: {detail[key]} <br/> </>;
            });
        } else 
            details = null;
        var SuggestedQuestion = null;
        return (
            <div className="card mt-2">
                <div className="card-header justify-content-between pd-10">
                    <h5 className="tx-14 lh-1  mg-b-0">Descriptions</h5>
                </div>
                <div className="list-group">
                    {descriptionData}
                </div>
                <div className="card-footer pd-10 mg-b-0">
                    <span className="tx-13 link-03">
                        {details}  
                    </span>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {
    return { enableDescription: state.dataSet.enableDescription } 
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        disablePageDescription,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DescriptionComponent);